import React from "react";
import PropTypes from "prop-types";

import Log from "utils/log";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  componentDidCatch(error, info) {
    this.setState({ error, info });
    Log.logger(error, "error", info, false);
  }

  render() {
    if (this.state.error) {
      // Render the error visibly in dev and staging. In prod, just don't render the content at all
      if (process.env.ENV === "production") return null;
      return (
        <div>
          <pre>{this.state.error.message}</pre>
          <pre>{this.state.info.componentStack}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
};



// WEBPACK FOOTER //
// ./src/components/Library/ErrorBoundary/ErrorBoundary.js